module.exports = __webpack_public_path__ + "img/32-indicadores-produtividade-hub.a2397e5d.png";